import { TipoPrestacionProps } from "./TipoPrestacionInterface";
import { TipoJuicioProps } from "./TipoJuicioInterface";

// Definición de defaults

export const defaultTipoPrestacionJuicio: TipoPrestacionJuicioProps = {
    idTipoPrestacionJuicio:    0,
    idTipoPrestacion:          0,
    idTipoJuicio:              0,
    activo:                    false
};

// Creación de interfaces

export interface TipoPrestacionJuicioProps {

  idTipoPrestacionJuicio:           number;
  idTipoPrestacion:                 number;
  tipoPrestacion?:                  TipoPrestacionProps;
  idTipoJuicio:                     number;
  tipoJuicio?:                      TipoJuicioProps
  activo:                           boolean;
}
